export enum RoutePath {
    VIEW_INVOICE = '/:invoiceId',
    PAY_INVOICE = '/:invoiceId/pay',
    INVOICE_LIST = '/invoicelist/:invoiceListId',
    PAY_INVOICE_LIST = '/invoicelist/:invoiceListId/:bulkPaymentId/pay',
    ACTIVITY = '/:invoiceId/activity',
}
